export const cleanAccidents = (accidents) => {
    return accidents.map(accident => {
        return {
            accidentDateUTC: accident.accidentDateUTC,
            accidentID: accident.accidentID,
        }
    })
}
